import React, { useCallback, useEffect, useState } from "react";
import "./Home.css";
import Banner from "../../components/banner/Banner";
import Title from "../../components/titles/Title";
import Benefits from "../../assets/images/Benefits.jpg";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Products from "../../components/products/Products";
import MainService from "../../common/MainService";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Circles } from "react-loader-spinner";
import RawHoney from "../../assets/images/honey-wooden-table-min.jpg";
import ProcessedHoney from "../../assets/images/honey.jpg";
import SemiProcessedHoney from "../../assets/images/semi-processed-honey.jpg";
import { NavLink } from "react-router-dom";
import ClientSection from "../../components/ClientSection/ClientSection";
import ReviewSection from "../../components/ReviewSection/ReviewSection";

// Main functional component for Home Page
export default function Home() {
  // Define state variables
  const [getHoneyProducts, setHoneyProducts] = useState([]);
  const [loding, setLoading] = useState(true); // typo in variable name (loding instead of loading)
  const [subCategory, setSubCategory] = useState([]);

  // Fetch config values from global window object
  const categoryId = `${window.livasaConfig.categoryId}`;
  const accessToken = localStorage.getItem("token");
  const user = `${window.livasaConfig.user}`;

  // Fetch products based on category
  const getAllProductsofUser = useCallback(() => {
    MainService.getAllProducts(categoryId)
      .then((res) => {
        setHoneyProducts(res);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [categoryId]);

  // Run once on component mount to load products
  useEffect(() => {
    getAllProductsofUser();
  }, [getAllProductsofUser]);

  // Fetch subcategories based on user and category
  const getAllSubCategory = useCallback(() => {
    if (!accessToken) return;

    MainService.getSubCategories(user, categoryId)
      .then((res) => {
        setSubCategory(res.contentsubcategories);
        setLoading(false);
      })
      .catch((e) => {
        console.log("Error", e);
      });
  }, [accessToken, user,categoryId]);

  // Run once on component mount to load subcategories
  useEffect(() => {
    getAllSubCategory();
  }, [getAllSubCategory]);

  // Slider settings for react-slick
  const settings = {
    infinite: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 1,
    responsive: [
      {
        initialSlide: 1,
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  // Mapping subcategory name to image
  const subcategoryImageMapping = {
    "Processed-Honey": ProcessedHoney,
    "Semi-Processed-Honey": SemiProcessedHoney,
    "Raw-Honey": RawHoney,
  };
  const defaultImageUrl = RawHoney;

  return (
    <div>
      {/* Banner Section */}
      <Banner />

      {/* Collections Section */}
      <div className="section-container">
        <Title classname="text-center mb-4 mb-lg-5" heading="Collections" />
        <div className="container">
          <Row className="justify-content-center">
            {!loding ? (
              <>
                {subCategory.map((data, index) => {
                  const imageUrl =
                    subcategoryImageMapping[data.contentsubcategoryname] ||
                    defaultImageUrl;
                  return (
                    <Col md={6} lg={3} key={index}>
                      <NavLink
                        to={`/collections/products/${data.contentsubcategoryname}/#products`}
                      >
                        <div className="card-container">
                          <div className="card-image-container mb-4">
                            <img
                              src={imageUrl}
                              alt={data.contentsubcategoryname}
                            />
                          </div>
                          <h5 className="text-center">
                            {data.contentsubcategoryname}
                          </h5>
                        </div>
                      </NavLink>
                    </Col>
                  );
                })}
              </>
            ) : (
              <div className="justify-content-center d-flex">
                <Circles color="orange" height={70} width={70} timeout={5000} />
              </div>
            )}
          </Row>
        </div>
      </div>

      {/* Best Seller Honey Section with Video */}
      <div className="section-container">
        <Title
          classname="text-center mb-lg-5 mb-3"
          heading="Best Seller Honey 🔥"
        />
        <div className="container">
          <iframe
            className="video-container"
            title="vimeo-player"
            src="https://player.vimeo.com/video/722834425?h=f3a1212ad5"
            loading="lazy"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            style={{ border: "none" }}
          ></iframe>
        </div>
      </div>

      {/* Livasa Products Carousel Section */}
      <div className="section-container">
        <div className="container">
          <div className="section-sub-container text-center">
            <Title name="text-center mb-4" heading="Livasa Natural Products" />
            <p className="mb-5">
              Livasa products are processed for a rich taste and quality.
            </p>
          </div>
          <Row>
            {!loding ? (
              getHoneyProducts.length !== 0 ? (
                <Slider {...settings}>
                  {getHoneyProducts.map((e, index) => (
                    <Col
                      key={index}
                      md={12}
                      lg={6}
                      sm={12}
                      xs={12}
                      className="px-3 justify-self-center"
                    >
                      <Products
                        src={e.productimageurl}
                        src1={e.qacertificateurl}
                        produtName={e.productfriendlyname}
                        discount={e.discountedprice}
                        productPrice={e.productcost}
                        origin={e.country}
                        url={e.infourl}
                        count={e.itemcount}
                        qr={e.productqrcodeurl}
                        likes={e.likes}
                        certificate={e.qacertificateurl}
                        model_id={e.productid}
                        likecount={e.likecount}
                        product={e}
                        buylink={e.buyurl}
                      />
                    </Col>
                  ))}
                </Slider>
              ) : (
                <h3 className="title">Products Not Found</h3>
              )
            ) : (
              <div className="justify-content-center d-flex">
                <Circles color="orange" height={70} width={70} timeout={5000} />
              </div>
            )}
          </Row>
        </div>
      </div>

      {/* Benefits of Honey Section */}
      <div className="section-container benefit-container">
        <div className="container">
          <div className="section-sub-container">
            <Title classname="text-center mb-4" heading="Benefits of Honey" />
            <p className="text-center mb-5">
              Livasa Pure Honey is a natural antioxidant. Honey is often used to
              build immunity and acts as a pre-workout energizer. A spoonful of
              honey is a perfect remedy for:
            </p>
          </div>
        </div>
        <img src={Benefits} alt="Benefits" />
      </div>

      {/* Clients Section */}
      <ClientSection />

      {/* Reviews Section */}
      <ReviewSection />
    </div>
  );
}
